import React, { Component } from 'react';
import {
  Route,
  NavLink,
  HashRouter
} from "react-router-dom";
import Home from "./Home";
import Counter from "./Counter";
import Weather from "./Weather";
import Repositories from "./Repositories";
import Todolist from "./Todolist";

class Main extends Component {
//	constructor(props) {
//		super(props);
//		this.state = {
//			open: false
//		};
//	}
//	
//	handleClick() {
//        console.log("was clicked");
//	}
    
  render() {
    /*<a class="w3-bar-item w3-button w3-hide-large w3-right w3-hover-white w3-theme-d2" onClick={ () => this.handleClick()}><i class="fa fa-bars"></i></a>*/
    return (
	<HashRouter>
	<div class="w3-content w3-card-4 w3-light-grey" style={{"max-width":1200}}>
	<header class="w3-container w3-center w3-padding-32"> 
		<h1><b>React tehtäviä</b></h1>
		<p>Ohjelmistokehityksen teknologioita <i>SWD4TN023-3</i></p>
	</header>
	<div class="w3-text-white navbar w3-bar w3-theme-d2 w3-left-align">
		<div class="w3-bar-item"><NavLink exact to="/">Home</NavLink></div>
		<div class="w3-bar-item"><NavLink to="/counter">Counter</NavLink></div>
		<div class="w3-bar-item"><NavLink to="/weather">Weather</NavLink></div>
        <div class="w3-bar-item"><NavLink to="/repositories">Repositories</NavLink></div>
        <div class="w3-bar-item"><NavLink to="/todolist">Todolist</NavLink></div>
	</div>
	  <div className="content">
		<Route exact path="/" component={Home}/>
		<Route path="/counter" component={Counter}/>
		<Route path="/weather" component={Weather}/>
        <Route path="/repositories" component={Repositories}/>
        <Route path="/todolist" component={Todolist}/>
	  </div>

	</div>
	</HashRouter>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js